// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3x6ZB","button":"styles_button__uDFNQ","title":"styles_title__3xc43","stepName":"styles_stepName__3nrrR","titleWrap":"styles_titleWrap__WMDeD"};